import styled from 'styled-components';

import { colours } from 'themes/default';

export const StyledTitleGroup = styled.div`
  display: flex;
`;

export const StyledBodyToggle = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  color: ${colours.Greyscale.White};
  cursor: pointer;
  display: flex;
  justify-content: center;
  margin: 0 0 0 16px;
  transform: rotate3d(0, 0, ${({ isActive }) => (isActive ? '1' : '0')}, 180deg);
  transition: transform 0.15s ease-in-out;
`;
